import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "./dict";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("korani-lang") || "el");
  useEffect(() => {
    localStorage.setItem("korani-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
